// Main
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"
vue.use(vuex);

// Store
const nacional = new vapi({
    namespaced: true,
    baseURL: `${process.env.VUE_APP_REST}/api/nacional`,
    state: {
        planesnacionales: [],
        plannacional: [],
        nacionales: [],
        nacionalelemento: null,
        planesnacionalessectoriales: [],
        archivo: "",
        imagen: ""
    }
}).get({
    action: "get_nacionales",
    onSuccess: (state, payload) => {
        //alert("get_nacionales");
        state.nacionales = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
        state.nacionales = []
        }
    })
    .get({
        action: "get_lista_periodos",
        path: function (obj) {
        // Recibe el parámetro idNacional
        const idNacional = obj && obj.idNacional !== undefined ? obj.idNacional : "0";
        return `GetPeriodos/${idNacional}`;
        },
        onSuccess: (state, payload) => {
        state.periodos = payload.data;
        },
        onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
        state.periodos = [];
        }
    })            
    .get({
        action: "get_vigencianacional",
        path: function (obj) {            
            console.log(JSON.stringify({ action: "get_vigencianacional:>", obj }));
            const idVigencia = typeof obj === "object" && obj !== null && obj.hasOwnProperty("filtroVigencia") ? obj.filtroVigencia : obj;
            const idNacional = typeof obj === "object" && obj !== null && obj.hasOwnProperty("idNacional") ? obj.idNacional : obj;
            return `GetVigencia/${idVigencia}/${idNacional}`;            
        },
        onSuccess: (state, payload) => {
            state.nacionales = payload.data;
        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
            state.nacionales = [];
        }
    })

    .get({
        action: "get_vistanacional",
        path: function () {
            return `/vistaciudadano/`;
        },
        onSuccess: (state, payload) => {
            state.planesnacionales = payload.data;
        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
        }
    }).get({
        action: "get_plannacional",
        path: function (obj) {
          //  alert("get_plannacional: " + JSON.stringify(obj));
            return `/vistaciudadano/${obj.idnacional}/${obj.idperiodo}`;
        },
        onSuccess: (state, payload) => {
            state.plannacional = payload.data;
        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
        }
    }).get({
        action: "get_plannacionalV2",
        path: function (obj) {
            return `/vistaciudadano/${obj.idnacional}/${obj.idperiodo}`;
        },
        onSuccess: (state, payload) => {
            state.plannacional = payload.data;
        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
        }
    })
    .get({
        action: "get_listapns",
        path: function () {
            return `/ListaPNS/`;
        },
        onSuccess: (state, payload) => {
            state.planesnacionalessectoriales = payload.data;
        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
        }
    }).get({
        action: "get_nacional",
        path: function (obj) {
           // alert("test1");
            return `${obj.idnacional}`
        },
        onSuccess: (state, payload) => {
            state.nacionalelemento = payload.data;
        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
        }
    })
    
    
    .get({
        action: "get_nacionalbyvigencia",
        path: function (obj) {
            // Espera un objeto con idnacional y vigencia
            const idnacional = obj && obj.idnacional !== undefined ? obj.idnacional : "0";
            const vigencia = obj && obj.vigencia !== undefined ? obj.vigencia : "0";
            return `GetByIdVigencia/${idnacional}/${vigencia}`;
        },
        onSuccess: (state, payload) => {
            console.log("get_nacionalbyvigencia: ", payload);
            state.nacionalelemento = payload.data;
        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
            state.nacionalelemento = null;
        }
    })

      .get({
        action: "get_nacionalbyvigenciaV2",
        path: function (obj) {
            // Espera un objeto con idnacional y vigencia
            const idnacional = obj && obj.idnacional !== undefined ? obj.idnacional : "0";
            const vigencia = obj && obj.vigencia !== undefined ? obj.vigencia : "0";
            return `GetByIdVigenciaV2/${idnacional}/${vigencia}`;
        },
        onSuccess: (state, payload) => {
            console.log("get_nacionalbyvigenciaV2: ", payload);
            state.nacionalelemento = payload.data;
        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
            state.nacionalelemento = null;
        }
    })
    
    .get({
        action: "get_nacionalformulacionimagen",
        path: function (obj) {
            return `imagennacionalformulacion/${obj.idnacionalformulacion}`
        },
        onSuccess: (state, payload) => {
            state.archivo = payload.data;
        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
        }
    })
    .get({
        action: "get_nacionalformulacionarchivo",
        path: function (obj) {
            return `archivonacionalformulacion/${obj.idnacionalformulacion}`
        },
        onSuccess: (state, payload) => {
            state.archivo = payload.data;
        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
        }
    })
    .get({
        action: "get_nacionalarchivo",
        path: function (obj) {
            return `archivo/${obj.idnacional}`
        },
        onSuccess: (state, payload) => {
            state.archivo = payload.data;
        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
        }
    }).get({
        action: "get_nacionalimagen",
        path: function (obj) {
            return `imagen/${obj.idnacional}`
        },
        onSuccess: (state, payload) => {
            state.imagen = payload.data;
        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
        }
    }).get({
        action: "get_nacionalbyname",
        path: function (obj) {
            return `nacionalpornombre/${obj.nombre}`;
        },
        onSuccess: (state, payload) => {
            state.planesnacionales = payload.data;
        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
        }
    }).post({
        action: "post_nacional",
        onSuccess: (state, payload) => {
            store.dispatch("mensaje/set_success", payload);
        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
        }
    }).put({
        action: "put_nacional",
        onSuccess: (state, payload) => {
            store.dispatch("mensaje/set_success", payload);
        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
        }
    }).delete({
        action: "delete_nacional",
        path: function (obj) {
            return `/${obj.idnacional}`
        },
        onSuccess: (state, payload) => {
            store.dispatch("mensaje/set_success", payload);
        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
        }
    }).getStore();

nacional.getters = {
    gnacionales: state => {
        return state.nacionales
    },
    gnacional: state => {
        return state.nacionalelemento
    },
    gvistanacional: state => {
        return state.planesnacionales
    },
    gplannacional: state => {
        return state.plannacional
    },
    gpns: state => {
        return state.planesnacionalessectoriales
    },
    gnacionalarchivo: state => {
        return state.archivo
    },
    gnacionalimagen: state => {
        return state.imagen
    }
}
export default nacional;
